var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-publish flex-column"},[_vm._m(0),_c('h1',[_vm._v("保存成功，请在我的漫画中提交审核")]),_c('el-button',{attrs:{"type":"primary","size":"large"},on:{"click":_vm.addChapterAgain}},[_vm._v("继续添加章节")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-publish-icons"},[_c('i',{staticClass:"el-icon-circle-check-outline"})])
}]

export { render, staticRenderFns }